<template>
    <div>
        <b-card no-body class="mb-3 p-20">
			<h2>Quotation Baru</h2>
		</b-card>

        <b-card no-body class="mt-4 p-20">
            <h4 class="underline-title">Data Customer</h4>
            <div class="row">
                <div class="col-12 col-lg-6 pl-3 pr-3">
                    <div class="row">
                        <div class="col-8 col-lg-4 mt-3 flex-middle" >
                            <label class="font-weight-bold">Nama Pelanggan<span style="color: red;">*</span></label>
                        </div>
                        <div class="col-12 col-lg-1 mt-3 flex-middle">
                            :
                        </div>
                        <div class="col-12 col-lg-7 mt-3">
                            <input type="text" class="form-control" placeholder="Ketik Nama Pelanggan" style="height: 43px;" v-model="form.name">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-8 col-lg-4 mt-3 flex-middle" >
                            <label class="font-weight-bold">Nomor Telepon<span style="color: red;">*</span></label>
                        </div>
                        <div class="col-12 col-lg-1 mt-3 flex-middle">
                            :
                        </div>
                        <div class="col-12 col-lg-7 mt-3">
                            <input type="text" class="form-control" placeholder="Ketik Nomor Telepon" style="height: 43px;" v-model="form.phone_number">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-8 col-lg-4 mt-3 flex-middle" >
                            <label class="font-weight-bold">Nomor Polisi Mobil<span style="color: red;">*</span></label>
                        </div>
                        <div class="col-12 col-lg-1 mt-3 flex-middle">
                            :
                        </div>
                        <div class="col-12 col-lg-7 mt-3">
                            <input type="text" class="form-control" placeholder="Ketik Nomor Polisi mobil" style="height: 43px;" v-model="form.registration">
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-6 pl-3 pr-3">
                    <div class="row">
                        <div class="col-8 col-lg-4 mt-3 flex-middle" >
                            <label class="font-weight-bold">Merk Mobil<span style="color: red;">*</span></label>
                        </div>
                        <div class="col-12 col-lg-1 mt-3 flex-middle">
                            :
                        </div>
                        <div class="col-12 col-lg-7 mt-3">
                            <MultiSelect
                                v-model="sparepart_brand_id"
                                :options="options.brand.map(x => x.id)"
                                :custom-label="opt => options.brand.find(x => x.id == opt).name"
                                :searchable="true"
                                :close-on-select="true"
                                :multiple="false"
                                :allow-empty="false"
                                placeholder="Pilih Merk Mobil"
                            ></MultiSelect>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-8 col-lg-4 mt-3 flex-middle" >
                            <label class="font-weight-bold">Tipe Mobil<span style="color: red;">*</span></label>
                        </div>
                        <div class="col-12 col-lg-1 mt-3 flex-middle">
                            :
                        </div>
                        <div class="col-12 col-lg-7 mt-3">
                            <MultiSelect
                                v-model="form.car_id"
                                :disabled="sparepart_brand_id == ''"
                                :options="options.model.map(x => x.id)"
                                :custom-label="opt => options.model.find(x => x.id == opt).name"
                                :searchable="true"
                                :close-on-select="true"
                                :multiple="false"
                                :allow-empty="false"
                                :placeholder="(sparepart_brand_id == '') ? 'Pilih Merk Terlebih Dahulu' : 'Pilih Tipe Mobil'"
                            ></MultiSelect>
                        </div>
                    </div>
                </div>
            </div>
        </b-card>

        <b-card no-body class="p-20 mt-4">
            <h4 class="underline-title">List Pekerjaan Quotation</h4>
            
            <label class="font-weight-bold mt-3">Harga Total (Belum Termasuk PPN)</label>
            <p style="font-size:1.8rem" :style="{'text-decoration: underline' : overallTotal!=0}">Rp. {{ numberWithCommas(overallTotal) }}</p>


            <table class="table table-striped mt-3">
                <thead>
                    <tr>
                    <th>No</th>
                    <th>Nama Sparepart</th>
                    <th>Tipe</th>
                    <th>Sparepart Size</th>
                    <th>Deskripsi Sparepart</th>
                    <th>Jumlah</th>
                    
                    <th>Harga Satuan</th>
                    <th>Harga Total</th>
                    <th><i class="fas fa-cog"></i></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(sparepart, index) in form.spareparts">
                        <td>{{ index+1 }}</td>
                        <td>{{sparepart.extension}} {{ sparepart.sparepart_name }}</td>
                        <td>{{ sparepart.sparepart_type}}</td>
                        <td>{{ sparepart.sparepart_size}}</td>
                        <td>{{ sparepart.part_number }}</td>
                        <td>{{ numberWithCommas(sparepart.quantity) }}</td>
                        
                        <td v-if="sparepart.sparepart_type != 'Part'">Rp. {{ numberWithCommas(sparepart.supplier_prices[0].price_per_item) }}</td>
                        <td v-else>Rp. {{numberWithCommas(sparepart.estimated_price)}}</td>
                        <td v-if="sparepart.sparepart_type != 'Part'">Rp. {{ numberWithCommas(sparepart.quantity * sparepart.supplier_prices[0].price_per_item) }}</td>
                        <td v-else>Rp. {{ numberWithCommas(sparepart.quantity * sparepart.estimated_price) }}</td>
                        <td>
                            <button type="button" class="btn btn-outline-danger" @click="form.spareparts.splice(index, 1)">
                            <i class="fas fa-times"></i>
                            </button>
                        </td>
                    </tr>
                    <tr v-if="form.spareparts.length == 0">
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>X</td>
                    </tr>
                </tbody>
            </table>
        </b-card>

        <div class="row">
            <div class="offset-lg-9 col-lg-3 col-12 mt-4">
                <button
                    class="btn btn-primary w-100"
                    @click="submitForm"
                >
                    Selesai Input Quotation
                </button>
            </div>
        </div>

        <b-card no-body class="p-20 mt-2">
            <h4 class="underline-title">Pilih Pekerjaan</h4>
            <hr>
            <!-- <h4 class="text-center mt-4" style="color:red" v-if="sparepart_brand_id == ''">Pilih Merek Mobil Terlebih Dahulu Untuk Pilih Pekerjaan</h4> -->
            <div>
                <div class="mt-2" v-if="page == 1">
                    <h5>Pilih Tipe Pekerjaan</h5>
                    <div class="mt-4 row">
                        <div class="col-md pl-3 pr-3">
                            <div class="shadow rounded flexify hoverable height-tipe" @click="selected = 'Part';page = 2">
                                <div>
                                    <i class="fa fa-cog fa-5x"></i>
                                </div>
                                <div class="mt-3">
                                    <h5>Part</h5>
                                </div>
                            </div>
                        </div>
                        <div class="col-md pl-3 pr-3">
                            <div class="shadow rounded flexify hoverable height-tipe" @click="selected = 'Jasa';page = 2;data.amount = 1">
                                <i class="fa fa-tools fa-5x"></i>
                                <h5 class="mt-3">Jasa</h5>
                            </div>
                        </div>
                        <div class="col-md pl-3 pr-3">
                            <div class="shadow rounded flexify hoverable height-tipe" @click="selected = 'Special Bahan';page = 2;">
                                <i class="fa fa-boxes fa-5x"></i>
                                <h5 class="mt-3">Special Bahan</h5>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else-if="page == 2">
                    <h5><i class="fa fa-arrow-left mr-3" @click="page = 1" style="cursor:pointer"></i>Pilih {{selected}}</h5>

                    <div class="pl-2 pr-2 mt-4">
                        <input class="form-control" :placeholder="'Cari ' + selected" v-model="search"/>
                    </div>
                    <div class="scrollable-card">
                        <div class="mt-2 row">
                            <div class="col-md-3 pl-3 pr-3 mt-3"  v-for="sparepart in sparepartMaster[selected].filter(x => x.alias.toLowerCase().includes(search.toLowerCase()) || x.name.toLowerCase().includes(search.toLowerCase())  )"  @click="searchSparepartID(sparepart)">
                                <div class="shadow rounded flexify hoverable height-item sub-text text-center">
                                    <div style="width:90%">
                                        <h5>{{sparepart.alias}}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="page == 3">
                    <h5><i class="fa fa-arrow-left mr-3" @click="page = 2" style="cursor:pointer"></i>Isi Data {{selected}} - {{curSparepart.sparepartInfo.sparepart_variants.alias}}</h5>
                    
                    <div v-if="selected == 'Special Bahan'">

                        <div class="row pl-3 pr-3 mb-3 mt-3">
                            <div class="col-md-4 mt-auto mb-auto">
                                <label class="label">Jumlah Stock</label>
                            </div>
                            <div class="col-md-1 mt-auto mb-auto">
                                <label class="label">:</label>
                            </div>
                            <div class="col-md-7 mt-auto mb-auto">
                                <!-- <input type="text" class="input--style-4" v-model="data.part_number"/> -->
                                <h5>{{numberWithCommas(curSparepart.sparepartInfo.stock)}}</h5>
                            </div>
                        </div>

                        <div class="row pl-3 pr-3">
                            <div class="col-md-4 mt-auto mb-auto">
                                <label class="label">Isi Deskripsi<span style="color: red;">*</span></label>
                            </div>
                            <div class="col-md-1 mt-auto mb-auto">
                                <label class="label">:</label>
                            </div>
                            <div class="col-md-7">
                                <input type="text" class="input--style-4" v-model="curSparepart.part_number"/>
                            </div>
                        </div>

                        <div class="row pl-3 pr-3 mt-3">
                            <div class="col-md-4 mt-auto mb-auto">
                                <label class="label">Jumlah Barang<span style="color: red;">*</span></label>
                            </div>
                            <div class="col-md-1 mt-auto mb-auto">
                                <label class="label">:</label>
                            </div>
                            <div class="col-md-7">
                                <input type="number" class="input--style-4" v-model="curSparepart.amount"/>
                            </div>
                        </div>

                        <div class="row pl-3 pr-3 mt-3">
                            <div class="col-md-4 mt-auto mb-auto">
                                <label class="label">Set Harga Special Bahan <span style="color:red">*</span></label>
                            </div>
                            <div class="col-md-1 mt-auto mb-auto">
                                <label class="label">:</label>
                            </div>
                            <div class="col-md-7">
                            <input type="text" v-model="curSparepart.price_per_item" class="input--style-4" />
                            </div>
                        </div>
                        <div class="row pl-3 pr-3 mt-3">
                            <div class="col-md-7 offset-md-5">
                                <div class="form-check form-check-inline col-12 mt-1">
                                    <input class="form-check-input" style="width:15%" type="checkbox" id="inlineCheckbox1" value="option1" v-model="curSparepart.without_ppn">
                                    <label class="form-check-label" for="inlineCheckbox1">Non PPN</label>
                                </div>
                                <div class="form-check form-check-inline col-12 mt-1">
                                    <input class="form-check-input" :disabled="curSparepart.without_ppn" style="width:15%" type="checkbox" id="inlineCheckbox1" value="option1" v-model="curSparepart.ppn_included">
                                    <label class="form-check-label"  for="inlineCheckbox1">Harga Termasuk PPN</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mt-4" v-else-if="selected == 'Jasa'">
                    
                        <div class="row pl-3 pr-3">
                            <div class="col-md-4 mt-auto mb-auto">
                                <label class="label">Jasa Extension</label>
                            </div>
                            <div class="col-md-1 mt-auto mb-auto">
                                <label class="label">:</label>
                            </div>
                            <div class="col-md-7">
                                <multi-select
                                    v-if="extensionList"
                                    :disabled="extensionList[0] == 'No Extension Available'"
                                    class="mt-1"
                                    :options="extensionList"
                                    placeholder="Pilih Extension Jasa"
                                    v-model="curSparepart.extension"
                                    :maxHeight="200"
                                />
                            </div>
                        </div>

                        <div class="row pl-3 pr-3 mt-3">
                            <div class="col-md-4 mt-auto mb-auto">
                                <label class="label">Tipe Jasa<span style="color: red;">*</span></label>
                            </div>
                            <div class="col-md-1 mt-auto mb-auto">
                                <label class="label">:</label>
                            </div>
                            <div class="col-md-7">
                                <multi-select
                                    class="mt-1"
                                    :options="['G/C' , 'R/C' , 'Special Repair', 'Inspeksi', 'B/P']"
                                    placeholder="Pilih Tipe Jasa"
                                    v-model="curSparepart.type"
                                    :maxHeight="200"
                                />
                            </div>
                        </div>

                        <div class="row pl-3 pr-3 mt-3">
                            <div class="col-md-4 mt-auto mb-auto">
                                <label class="label">Sparepart Size<span style="color: red;">*</span></label>
                            </div>
                            <div class="col-md-1 mt-auto mb-auto">
                                <label class="label">:</label>
                            </div>
                            <div class="col-md-7">
                                <multi-select
                                    class="mt-1"
                                    :options="options.sparepartSizes.map(x => x.id).sort()"
                                    :custom-label="opt => options.sparepartSizes.find(x => x.id == opt).name"
                                    label="name"
                                    placeholder="Pilih Sparepart Mobil"
                                    v-model="curSparepart.sparepart_size"
                                />

                            </div>
                        </div>

                        
                        <div class="row pl-3 pr-3 mt-3">
                            <div class="col-md-4 mt-auto mb-auto">
                                <label class="label">Isi Deskripsi<span style="color: red;">*</span></label>
                            </div>
                            <div class="col-md-1 mt-auto mb-auto">
                                <label class="label">:</label>
                            </div>
                            <div class="col-md-7">
                                <input type="text" class="input--style-4" v-model="curSparepart.part_number"/>
                                <div class="row mt-2">
                                    <div class="col-4" v-for="description in descriptionList">
                                        <button class="btn btn-secondary" type="button" @click="curSparepart.part_number = description">{{description}}</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row pl-3 pr-3 mt-3">
                            <div class="col-md-4 mt-auto mb-auto">
                                <label class="label">Jumlah Barang<span style="color: red;">*</span></label>
                            </div>
                            <div class="col-md-1 mt-auto mb-auto">
                                <label class="label">:</label>
                            </div>
                            <div class="col-md-7">
                                <input type="number" class="input--style-4" disabled v-model="curSparepart.amount"/>
                            </div>
                        </div>

                        <div class="row pl-3 pr-3 mt-3">
                            <div class="col-md-4 mt-auto mb-auto">
                                <label class="label">Set Harga Jasa <span style="color:red">*</span></label>
                            </div>
                            <div class="col-md-1 mt-auto mb-auto">
                                <label class="label">:</label>
                            </div>
                            <div class="col-md-7">
                            <input type="text" v-model="curSparepart.price_per_item" class="input--style-4" />
                            <div class="form-check form-check-inline col-12">
                                    <input class="form-check-input" style="width:15%" type="checkbox" id="inlineCheckbox1" value="option1" v-model="curSparepart.without_ppn">
                                    <label class="form-check-label" for="inlineCheckbox1">Non PPN</label>
                                </div>
                                <div class="form-check form-check-inline col-12">
                                    <input class="form-check-input" :disabled="curSparepart.without_ppn" style="width:15%" type="checkbox" id="inlineCheckbox1" value="option1" v-model="curSparepart.ppn_included">
                                    <label class="form-check-label"  for="inlineCheckbox1">Harga Termasuk PPN</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mt-4" v-if="selected == 'Part'">
                        <div class="row pl-3 pr-3">
                            <div class="col-md-4 mt-auto mb-auto">
                                <label class="label">Isi Deskripsi<span style="color: red;">*</span></label>
                            </div>
                            <div class="col-md-1 mt-auto mb-auto">
                                <label class="label">:</label>
                            </div>
                            <div class="col-md-7">
                                <input type="text" class="input--style-4" v-model="curSparepart.part_number"/>
                            </div>
                        </div>

                        <div class="row pl-3 pr-3 mt-3">
                            <div class="col-md-4 mt-auto mb-auto">
                                <label class="label">Jumlah Barang<span style="color: red;">*</span></label>
                            </div>
                            <div class="col-md-1 mt-auto mb-auto">
                                <label class="label">:</label>
                            </div>
                            <div class="col-md-7">
                                <input type="number" class="input--style-4" v-model="curSparepart.amount"/>
                            </div>

                        </div>
                        
                        <div class="row pl-3 pr-3 mt-3">
                            <div class="col-md-4 mt-auto mb-auto">
                                <label class="label">Set Harga Part<span style="color: red;">*</span></label>
                            </div>
                            <div class="col-md-1 mt-auto mb-auto">
                                <label class="label">:</label>
                            </div>
                            <div class="col-md-7">
                                <input type="text" class="input--style-4" v-model="curSparepart.price_per_item"/>
                            </div>
                        </div>

                        
                    </div>
                    <div class="row mt-4 mr-2">
                        <div class="col-lg-3 offset-lg-9 col-12">
                            <button class="btn btn-outline-success w-100" @click="addToTable">Tambah Pekerjaan</button>
                        </div>
                    </div>
                </div>
            </div>
        </b-card>

    </div>
</template>

<script>
export default {
    mounted () {
        this.loadSparepartData()
    },
    data () {
        return {
            form : {
                name : '',
                phone_number : '',
                car_id : '',
                registration : '',
                spareparts : []
            },
            options : this.$store.getters.getFilterOptions,
            sparepart_brand_id : '',
            page : 1,
            selected : '',
            sparepartMaster : null,
            search : '',
            curSparepart : null,
            model : {
                sparepart_type: null,
				sparepart_name: null,
				sparepart_id: null,
                sparepart_size: null,
				part_number: "",
				amount: "",
				type: "",
				extension: "",
				estimated_price : 0,
            },
            modelSupplierPrices : {
                ppn_included: false,
                price_per_item: "",
                without_ppn: false,
                inden: 0,
            },
            extensionList : [],
            descriptionList : [],
            processing : false
        }
    },
    computed : {
        overallTotal(){
            var total = 0;
            for(var i in this.form.spareparts){
                let price = this.form.spareparts[i].sparepart_type != 'Part' ? this.form.spareparts[i].supplier_prices[0].price_per_item : this.form.spareparts[i].estimated_price
                total += (price * this.form.spareparts[i].quantity)
            }
            return total;
        }
    },
    watch : {
        'sparepart_brand_id'(){
            // console.log(JSON.stringify(this.$store.getters.getSingleModelId(this.form.brand)));
            this.form.car_id = '';
            this.options.model = this.$store.getters.getSingleModelId(this.sparepart_brand_id)
        },
        'form.registration' : function () {
				const result = this.form.registration.toUpperCase();
				this.$nextTick(() => this.form.registration = result);
        },
        page : function () {
            this.search = ''
        },
        'curSparepart.price_per_item': function() {
			const result = this.curSparepart.price_per_item
				.replace(/\D/g, "")
				.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			this.$nextTick(
				() => (this.curSparepart.price_per_item = result)
			);
		}
    },
    methods : {
        loadSparepartData () {
			this.sparepartMaster = null

			let data = {
				Jasa : [],
				Part : [],
				Bahan : [],
                'Special Bahan' : []
			}
			this.$http.get(`/api/v1/masterData/sparepart/variants?pagination=false&countEstimation=true`)
			.then((resp) => {
				let sparepartMaster = resp.data.data
				for(var i = 0 ; i < sparepartMaster.length ; i++) {
                    if(sparepartMaster[i].sparepart_type.id == 1 && sparepartMaster[i].is_show) {
                        data.Jasa.push(sparepartMaster[i])
                    }
                    else if(sparepartMaster[i].sparepart_type.id == 2) {
                        data.Part.push(sparepartMaster[i])
                    }
                    else if(sparepartMaster[i].sparepart_type.id == 4) {
                        data['Special Bahan'].push(sparepartMaster[i])
                    }
				}

				this.sparepartMaster = data
				// console.log(this.sparepartMaster)
			})
			.catch((err) => {console.log(err)})
		},
        searchSparepartID (sparepart ) {
			let url = `/api/v1/masterData/sparepart`

            this.curSparepart = Object.assign({} , this.model)
            if(this.selected != 'Part')
                this.curSparepart.supplier_prices = [Object.assign({} , this.modelSupplierPrices)]

			this.$http.get(url + `?variant_id=${sparepart.id}`)
			.then((resp) => {
				// this.data.sparepart_id = resp.data.data[0]
                let data = resp.data.data[0]
                console.log(data)
                this.curSparepart.sparepart_id = resp.data.data[0].id
                this.curSparepart.sparepartInfo = data
                this.curSparepart.sparepart_type = this.selected
                if(this.selected == 'Jasa')
                    this.curSparepart.amount = 1

                if(data.sparepart_variants.extension){
                    this.extensionList = data.sparepart_variants.extension.split(',')
                }

                if(data.sparepart_variants.description){
                    this.descriptionList = data.sparepart_variants.description.split(',')
                }
                
                this.page++;
                console.log(this.curSparepart)

			})
			.catch((err) => {
				console.log(err)
			})
		},
        addToTable () {
            console.log(this.curSparepart)
            let newObj = {}

            newObj.sparepart_id = this.curSparepart.sparepart_id
            newObj.sparepart_name = this.curSparepart.sparepartInfo.sparepart_variants.alias
            newObj.sparepart_type = this.selected

            if(this.selected == 'Special Bahan') {
                let formCheck = [{
                    var : 'amount',
                    name : 'Jumlah Barang'
                },{
                    var : 'part_number',
                    name : 'Deskripsi'
                },{
                    var : 'price_per_item',
                    name : 'Harga Barang'
                }]

                let validate = this.validateForm(formCheck , this.curSparepart)
                if(validate) {
                    this.$store.dispatch('triggerAlert' , [false , validate])
                    return
                }

                newObj.quantity = parseInt(this.curSparepart.amount)
                newObj.part_number = this.curSparepart.part_number
                newObj.supplier_prices = this.curSparepart.supplier_prices
                newObj.supplier_prices[0].ppn_included = this.curSparepart.ppn_included ? this.curSparepart.ppn_included : false
                newObj.supplier_prices[0].without_ppn = this.curSparepart.without_ppn ? this.curSparepart.without_ppn : false
                newObj.supplier_prices[0].price_per_item = parseFloat(this.curSparepart.price_per_item.split(',').join(''))
            }
            else if(this.selected == 'Jasa') {
                let formCheck = [{
                    var : 'amount',
                    name : 'Jumlah Barang'
                },{
                    var : 'part_number',
                    name : 'Deskripsi'
                },{
                    var : 'price_per_item',
                    name : 'Harga Barang'
                },{
                    var : 'type',
                    name : 'Tipe Jasa'
                },{
                    var : 'sparepart_size',
                    name : 'Sparepart Size'
                }]

                let validate = this.validateForm(formCheck , this.curSparepart)
                if(validate) {
                    this.$store.dispatch('triggerAlert' , [false , validate])
                    return
                }

                newObj.quantity = parseInt(this.curSparepart.amount)
                newObj.part_number = this.curSparepart.part_number
                newObj.supplier_prices = this.curSparepart.supplier_prices
                newObj.supplier_prices[0].ppn_included = this.curSparepart.ppn_included ? this.curSparepart.ppn_included : false
                newObj.supplier_prices[0].without_ppn = this.curSparepart.without_ppn ? this.curSparepart.without_ppn : false
                newObj.supplier_prices[0].price_per_item = parseFloat(this.curSparepart.price_per_item.split(',').join(''))
                newObj.extension = this.curSparepart.extension
                newObj.sparepart_size = this.curSparepart.sparepart_size
                newObj.type = this.curSparepart.type
            }
            else {
                let formCheck = [{
                    var : 'amount',
                    name : 'Jumlah Barang'
                },{
                    var : 'part_number',
                    name : 'Deskripsi'
                },{
                    var : 'price_per_item',
                    name : 'Harga Barang'
                }]

                let validate = this.validateForm(formCheck , this.curSparepart)
                if(validate) {
                    this.$store.dispatch('triggerAlert' , [false , validate])
                    return
                }

                newObj.quantity = parseInt(this.curSparepart.amount)
                newObj.part_number = this.curSparepart.part_number
                newObj.estimated_price = parseFloat(this.curSparepart.price_per_item.split(',').join(''))
            }

            this.form.spareparts.push(newObj)
            this.selected = null
            this.curSparepart = null
            this.page = 1

            console.log(newObj)
        },
        validateForm(varToBeChecked , form) {
            let error = null

            for(var i = 0 ; i < varToBeChecked.length ; i++) {
                let curVar = varToBeChecked[i]
                if(!form[curVar.var]) {
                    error = `${curVar.name} Tidak Boleh Kosong`
                    break;
                }
            }

            return error
        },
        validateQuotation(){
            var valid = true;
            var error = [];

            if(this.form.name == '' || this.form.name == null){//Customer Name [Required]
                valid = false;
                error.push('Nama pelanggan wajib terisi');
            }

            // if(this.form.phone_number == '' || this.form.phone_number == null){//Nomor Telepon [Required]
            //     valid = false;
            //     error.push('Nama Telepon wajib terisi');
            // }

            if(this.form.car_id == '' || this.form.car_id == null){//Car ID [Required]
                valid = false;
                error.push('Tipe mobil wajib terisi');
            }

            if(this.form.spareparts.length == 0){//Spareparts [Required]
                valid = false;
                error.push('Wajib ditambahkan setidaknya 1 suku cadang');
            }

            if(!valid) this.$store.dispatch('triggerAlert', [false, error]);
            else return valid;
        },
        async submitForm(){
            let vm = this;
            if(this.processing) {
                this.$store.dispatch('triggerAlert' , [false , 'Customer Quotation is processing. please wait.'])
                return
            }
            this.processing = true
            if(vm.validateQuotation()){
                for(var i in this.form.spareparts){
                    delete this.form.spareparts[i].sparepart_type
                    delete this.form.spareparts[i].sparepart_name
                }
                this.$http.post('/api/v1/quotation', {data:this.form})
                .then((resp)=>{
                    this.$swal.fire({
                        title: resp.data.data.form_code,
                        text: 'Kode Referensi',
                        type: 'success'
                    }).then((result)=>{
                        this.$router.push({name : 'CSOCustomerQuotationView'});
                        this.processing = false
                    })
                })
                .catch((err)=>{
                    console.log(err.response.data);
                    this.$store.dispatch('triggerAlert' , [false , err.response.data.data])
                    this.processing = false
                })
            }
            else {
                this.processing = false
            }
        },
    }
}
</script>>

<style scoped>
    .flex-middle {
        display: flex;
        /* justify-content: center; */
        align-items: center;
    }

    .underline-title {
        text-decoration-line: underline;
        text-underline-offset: 6px;
    }

    .scrollable-card {
        height: 390px;
        overflow-y: scroll;
    }

    .flexify {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

    .height-tipe {
        height : 320px;
    }

    .height-item {
        height : 80px;
    }
    .hoverable:hover {
        color : white;
        background-color: darkslategrey;
    }

    .sub-text{
        white-space: normal;
    }
</style>